module.exports = __webpack_public_path__ + "img/thumbnail_AsianWaterMonitor_m_erythristic.07d53849.png";